import React from "react";
import "./styles/PageHeader.css";

/**
 * PageHeader - Title block for a screen, with actions on the right.
 *
 * @param {Object} props
 * @param {string} props.eyebrow - Small label above the title (section, breadcrumb)
 * @param {string} props.title - Page title
 * @param {string|number} props.count - Optional count pill beside the title
 * @param {string} props.description - One line explaining what the screen is for
 * @param {React.ReactNode} props.actions - Buttons for the right-hand side
 */
const PageHeader = ({ eyebrow, title, count, description, actions }) => {
  return (
    <header className="pageHeader">
      <div className="pageHeaderText">
        {eyebrow && <span className="pageHeaderEyebrow">{eyebrow}</span>}
        <div className="pageHeaderTitleRow">
          <h1 className="pageHeaderTitle">{title}</h1>
          {count !== undefined && count !== null && (
            <span className="pageHeaderCount">{count}</span>
          )}
        </div>
        {description && <p className="pageHeaderDescription">{description}</p>}
      </div>
      {actions && <div className="pageHeaderActions">{actions}</div>}
    </header>
  );
};

export default PageHeader;
